export default "__VITE_ASSET__Dh1QP6rV__"